export var ShowMapCommand = function(eventArg) {
  this.showWebMap = eventArg;
}
ShowMapCommand.prototype = {
  constructor: ShowMapCommand,
  exec: function(vueScope) {
    if (this.showWebMap) {
      $('#webmap').show();
    } else {
      $('#webmap').hide();
    }
  }

}


// WEBPACK FOOTER //
// ./src/plugins/components/Web3dModels/commands/ShowMapCommand.js